export const ADD_INVOICES = 'ADD_INVOICES';
export const CLEAR_INVOICES = 'CLEAR_INVOICES';
export const SET_DATE_FILTER = 'SET_DATE_FILTER';
export const SET_INVOICE_NAME_FILTER = 'SET_INVOICE_NAME_FILTER';
export const SET_MOONSHOT_INVOICE_FLAG = 'SET_MOONSHOT_INVOICE_FLAG';
export const GET_INVOICE_PDF = 'GET_INVOICE_PDF';
